// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import {
  incrementFilter,
  setFiltersList,
  setList,
  addFilter,
  setFilter,
  removeFilter,
} from '%/stores/Filters/UsedVehicles/FilterV3';
import {
  parseFiltersStoreStateToComponentState
} from '%/utils/filters/usedVehicles/parseFiltersStoreStateToComponentState';
import { mapFiltersV2 } from '%/utils/filters/usedVehicles/mapFiltersV2';
import { makeFiltersPillData } from '%/utils/filters/usedVehicles/portalUsedVehiclesV2/makeFiltersPillData';
import { resetFilter } from '../../../../../stores/Filters/UsedVehicles/FilterV3';

class Pills extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pills: [],
      unitsOptions: [],
    }

    this.parseFiltersListToPills = this.parseFiltersListToPills.bind(this);
    this.watchStore = this.watchStore.bind(this);
  }

  componentDidMount() {
    this.watchStore()
  }

  watchStore() {
    window.store.UsedVehiclesFilter.watch(incrementFilter, this.parseFiltersListToPills);
    window.store.UsedVehiclesFilter.watch(setFiltersList, this.parseFiltersListToPills);
    window.store.UsedVehiclesFilter.watch(addFilter, this.parseFiltersListToPills);
    window.store.UsedVehiclesFilter.watch(setFilter, this.parseFiltersListToPills);
    window.store.UsedVehiclesFilter.watch(removeFilter, this.parseFiltersListToPills);
    window.store.UsedVehiclesFilter.watch(resetFilter, this.parseFiltersListToPills);
    window.store.FilterOptions.watch((state) => {
      const { options } = state

      if (options && Object.keys(options).length > 0) {
        this.setState({
          unitsOptions: options.units
        })

        const filtersList = window.store.UsedVehiclesFilter.getState().filtersList
        this.parseFiltersListToPills({ filtersList });
      }
    });
  }

  parseFiltersListToPills(state) {
    const { filtersList } = state
    if (!filtersList) return

    const parsedFiltersList = parseFiltersStoreStateToComponentState(filtersList)
    if (!parsedFiltersList) return

    const { unitsOptions } = this.state
    const filtersPillsData = makeFiltersPillData(parsedFiltersList, unitsOptions)

    this.setState({
      pills: filtersPillsData
    })
  }

  handlePillCloseClick(pill) {
    const rangeFiltersKeys = ['min_price', 'max_price', 'min_model_year', 'max_model_year', 'min_km', 'max_km', 'keyword']
    const filterValue = rangeFiltersKeys.includes(pill.key) ? null : pill.originalValue
    
    const filter = {
      key: mapFiltersV2[pill.key],
      value: filterValue
    }
    
    return (event) => {
      event.stopPropagation()

      incrementFilter(filter)
      setList();
    }
  }
  
  render() {
    const { pills } = this.state
    
    return ( 
      <ul className="advanced-filter__pills">
        {pills.length > 0 && pills.map(pill => (
          <li
            className="advanced-filter__pill"
            key={`${pill.key}-${pill.value}`}
          >
            {pill.value}
            <button onClick={this.handlePillCloseClick(pill)}>
              <i className="icon icon-close" />
            </button>
          </li>
        ))}
      </ul>
    );
  }
}

Pills.defaultProps = {};

Pills.propTypes = {};

export default Pills;
